import type { CoreApiClient } from "../client";
import type { Building, PatchBuildingByIdRequestBody, PostBuildingsRequestBody } from "../types/building.type";

export const createBuildingMutations = (api: CoreApiClient) => {
  const { request } = api;

  const create = async (body: PostBuildingsRequestBody): Promise<Building> => {
    const { data } = await request("post", "/buildings", { body });
    return data;
  };

  const update = async (buildingId: string, body: PatchBuildingByIdRequestBody): Promise<Building> => {
    const { data } = await request("patch", "/buildings/{buildingId}", {
      params: {
        path: {
          buildingId,
        },
      },
      body,
    });
    return data;
  };

  const remove = async (buildingId: string): Promise<void> => {
    await request("delete", "/buildings/{buildingId}", {
      params: {
        path: {
          buildingId,
        },
      },
    });
  };

  return {
    create,
    update,
    remove,
  };
};
